import { css } from "emotion";

export const container = css`
    border: 1px solid #dddddd;
    border-top: 1px solid #999;
    border-radius: 5px;
    overflow: hidden;
    font-size: 0;
    line-height: 0;
`;

export const containerFocus = css(
    container,
    css`
        border-color: #000;
    `
);

export const containerValidationFailure = css`
    border-color: red;
`;

export const textareaInput = css`
    position: relative;
    resize: vertical;
    width: 100%;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 15px;
    padding: 11.5px 15px 7.5px 15px;
    border: 0;
    box-sizing: border-box;
    &:focus {
        border-color: #000;
    }
`;

export const mediaInputsWrapper = css`
    display: block;
    padding: 12px 18px;
    background-color: #fff;
    margin-top: -6px;
    border-top: 1px solid #ddd;
`;

export const videoButton = css`
    margin-left: 10px;
`;

export const buttonsDescription = css`
    font-size: 12px;
    margin-left: 10px;
`;